import type { UnitInfoSplitInterface } from 'store/units/types';
import { BaseUnitConfig } from 'unitData/BaseUnitConfig';
import type { UnitConfigParams } from 'unitData/BaseUnitConfig';

export enum splitTypes {
  PERCENT = 'PERCENT',
  TON = 'TON',
}
export enum nbrOfOutputs {
  TWO = 2,
  THREE = 3,
}

/**
 * Returns the default unitinfo object for a Split unit
 */
export const getDefaultData = (
  noOutputs: number = nbrOfOutputs.TWO,
): UnitInfoSplitInterface => {
  return {
    unitName: 'Split',
    splitType: splitTypes.PERCENT,
    nbrOfOutputs: noOutputs,
    noMassBalance: false,
    amountLeft: 50,
    amountRight: 0,
    amountMiddle: 0,
    angle: 0,
    display: {
      displayNotes: {
        noteOne: false,
        noteTwo: false,
        noteThree: false,
        noteFour: false,
        noteFive: false,
      },
      displaySplitSettings: false,
    },
  };
};

export class SplitConfig extends BaseUnitConfig {
  getDefaultData(params?: UnitConfigParams): UnitInfoSplitInterface {
    const variantId = params?.variantId ?? nbrOfOutputs.TWO;

    return {
      unitName: 'Split',
      splitType: splitTypes.PERCENT,
      nbrOfOutputs: variantId,
      noMassBalance: false,
      amountLeft: 50,
      amountRight: 0,
      amountMiddle: 0,
      angle: 0,
      display: {
        displayNotes: {
          noteOne: false,
          noteTwo: false,
          noteThree: false,
          noteFour: false,
          noteFive: false,
        },
        displaySplitSettings: false,
      },
    };
  }

  getNumberOfPorts(model?: string, variantId?: number): number {
    const numOutputs = variantId ?? nbrOfOutputs.TWO;
    return 1 + numOutputs;
  }
}

export const splitConfig = new SplitConfig();
